module.exports = __webpack_public_path__ + "static/media/review_01.7e12c8ee.mp4";